<div class="ptf-tables" uppDataid="ptf-tables">
    <ng-container *ngIf="place">
        <div *ngIf="ShowFloor && FloorSelected" class="ptf-tables__floor" uppDataid="ptf-tables-floor-view">
            <upp-floor-view [area]="FloorSelected" (OnSelected)="OnDrawSelected($event)"></upp-floor-view>
        </div>

        <upp-scrollable *ngIf="!ShowFloor" uppDataid="ptf-tables-grid-scroll">
            <ion-card *ngIf="!HasTables" class="empty" uppDataid="ptf-tables-empty">
                <ion-card-header>
                    <ion-card-title>{{ tr('@place_tables_empty_title') }}</ion-card-title>
                </ion-card-header>
                <ion-card-content>{{ tr('@place_tables_empty_message') }}</ion-card-content>
            </ion-card>

            <upp-grid *ngIf="HasTables" name="PTF_TABLES_GRID" uppDataid="ptf-tables-grid">
                <upp-grid-item
                    *ngFor="let table of tables; trackBy: TableTrack"
                    [uppDataid]="'ptf-tablethumb-' + table.number + '-grid-item'"
                    (click)="OnSelectTable(table)"
                >
                    <upp-qrcode-thumb target="DISPLAY" [qrcode]="table"></upp-qrcode-thumb>
                </upp-grid-item>
            </upp-grid>
        </upp-scrollable>
    </ng-container>
</div>
